var version = require("./version")

module.exports = isVirtualText

function isVirtualText(x) {
    return x && x.type === "VirtualText" && x.version === version
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vnode/is-vtext.js
// module id = 25
// module chunks = 0